import { AfterViewInit, Component, Input, OnInit, ViewChild, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { ResponseAnswerUpdateRequest } from 'src/models/response.model';
import { ResponseService } from 'src/services/response.service';
import { FormsModule } from '@angular/forms';
import { combineLatest, debounceTime, fromEvent, throwError } from 'rxjs';
import { SharedDataService } from 'src/services/shared-data.service';
import { ReplacePatientTermPipe, SanitizeHtmlPipe } from '../filter-section.pipe';
import { ResponseText } from 'src/models/app-enums.model';
import { CdkTextareaAutosize, TextFieldModule } from '@angular/cdk/text-field';
import { take } from 'rxjs/operators';
import { QuestionnaireResponseQuestion } from 'src/models/questionnaire-response.model';
import { DateUtil } from 'src/app/shared/utils/date.util';

@Component({
  selector: 'app-answer-textbox',
  templateUrl: './answer-textbox.component.html',
  styleUrls: ['./answer-textbox.component.css'],
  standalone: true,
  imports: [MaterialModule, CommonModule, FormsModule, ReplacePatientTermPipe, TextFieldModule, SanitizeHtmlPipe]
})
export class AnswerTextboxComponent implements OnInit, AfterViewInit {

  @ViewChild("myTextArea") myTextArea: CdkTextareaAutosize | undefined;
  textArea!: any;

  @Input() question!: QuestionnaireResponseQuestion;
  isPreview: boolean = false;
  patientTerm!: string;
  culture: string | undefined = $localize.locale

  maxCharacterCount = ResponseText.maxCharacterCount;
  textAreaPlaceHolderLine = $localize`Note that comments are not monitored or reviewed by HSO / AC Staff. Comments are provided verbatim.\nNote that the maximum number of characters accepted by the on-line survey system is ${this.maxCharacterCount}.\n\nEXAMPLE RESPONSE:\nWorkstations should be cleaned more regularly. Team building events should be held to improve collaboration. The organization should continue to make incident reporting quick and easy - it makes an important part of our jobs much more straightforward.`;

  constructor(
    private _responseService: ResponseService, 
    private _sharedDataService: SharedDataService, 
    private ngZone: NgZone
  ) { }

  triggerResize() {
    // Wait for changes to be applied, then trigger textarea resize.
    this.ngZone.onStable.pipe(take(1)).subscribe(() => this.myTextArea!.resizeToFitContent(true));
  }

  ngOnInit(): void {

    combineLatest([this._sharedDataService.previewMode$, this._sharedDataService.patientTerm$])
      .subscribe(([isPreview, patientTerm]) => {
        this.isPreview = isPreview
        this.patientTerm = patientTerm
      }
    )
  }

  ngAfterViewInit(): void {

    this.textArea = document.getElementById('textAreaBox');     
    if (this.textArea !== undefined){
      fromEvent(this.textArea, 'keyup').pipe(
        debounceTime(60000)
      ).subscribe(() => {
        this.saveAnswer()
      })
    }
    
  }

  /**
   * 
   */
  saveAnswer() {

    if(this.question.answers.length === 0) {
      throw throwError('Answer was not found')
    }

    const selectedAnswerTemp = this.question.answers[0]
    
    const responseAnswerUpdateRequest : ResponseAnswerUpdateRequest = {
      responseId: this._sharedDataService.questionnaireResponse!.responseId,
      question: {
        questionId: this.question.questionId,
        responseText: this.question.responseText,
        answers: [
          {
            ...selectedAnswerTemp,
            selected: true,
            responseTimestamp: DateUtil.toISOString(new Date())
          }
        ]
      },
      isPreview: this.isPreview
    }

    this._responseService.updateSingleAnswerForResponse(responseAnswerUpdateRequest).subscribe(() => {
      // update global questions
      this.question.answers = this.question.answers.map(ans => {
        ans.selected = ans.answerId === selectedAnswerTemp.answerId
        return ans
      })
      this.question.isAnswered = true;
    })
  }

  openPrivacyPolicy()
  {
    switch (this.culture?.toLocaleLowerCase())
    {
      case ('fr-ca'):
        window.open("https://healthstandards.org/fr/avis-de-confidentialite-plateforme-de-sondage-hso/", '_blank');
        break;
      default:
        window.open("https://healthstandards.org/privacy-notice-hso-survey-instruments-platform/", '_blank');
        break;
    }
  }

  openTermsOfUse()
  {
    switch (this.culture?.toLocaleLowerCase())
    {
      case ('fr-ca'):
        window.open("https://healthstandards.org/terms-of-use-survey-instruments-platform/", '_blank');
        break;
      default:
        window.open("https://healthstandards.org/terms-of-use-survey-instruments-platform/", '_blank');
        break;
    }
  }
}

